module.exports = global.config = {
    theme: 'light',
    currency: {
        name: 'BRL',
        language: 'pt-BR'
    },
    language: 'pt-BR'
};

